export const HDI_ROLE_OWNER = 'OWNER';
export const HDI_ROLE_EDITOR = 'EDITOR';
